<template>
    <div class="main">
<!--        <Loading v-show="loading"/>-->

        <div class="main-center scroll">
            <div class=" dashboard-content">
                <h1>Dashboard</h1>
                <div class="filter-line margin-t-25">
	                <div class="flex">
		                <filters_panel @change="loadAnalytics()" />
	                </div>

	                <div class="layout-row range-wrapper">
		                <range-picker :end-date="endDate" :start-date="startDate" :min-date="minDate" :max-date="maxDate"
		                              @rangeChanged="rangeChanged" :loading="!chartsLoaded" @reload="loadAnalytics()"/>

		                <!--		        TODO: period comparission selection -->
		                <!--						<span class="compare-to"> compare to </span>-->
		                <!--		        <range-picker :end-date="endDate" :start-date="startDate" :max-date="maxDate" @rangeChanged="rangeChanged"/>-->
	                </div>
                </div>
                <div class="chart-box">
                  <chart title="Revenue" :data="values['revenue']" :old-data="oldValues['revenue']" :prefix="currencyCode"
                         :total="summary['revenue'].value" :old-total="summary['revenue'].old_value" is-money large
                         :startDate="chartStart" :endDate="chartEnd" :loading="loading['revenue']"/>
                </div>

                <div class="layout-column dashboard" style="margin-top: 40px;">
	                <div class="layout-row" >
		                <chart title="Uniq. Orders" :data="values['unique_orders']" :old-data="oldValues['unique_orders']" :round-value="true"
		                       :total="summary['unique_orders'].value" :old-total="summary['unique_orders'].old_value" small
		                       :startDate="chartStart" :endDate="chartEnd" :loading="loading['unique_orders']"/>

		                <chart title="Conv. rate" :data="values['conv_rate']" :old-data="oldValues['conv_rate']" suffix="%"
		                       :total="summary['conv_rate'].value" :old-total="summary['conv_rate'].old_value" small
		                       :startDate="chartStart" :endDate="chartEnd" :loading="loading['conv_rate']">
			                <template v-slot:info>
				                This is the <b>Conversion Rate</b> of pages on all your funnels combined.
			                </template>
		                </chart>

		                <chart title="AOV" :data="values['aov']" :old-data="oldValues['aov']" :round-value="true"
		                       :total="summary['aov'].value" :old-total="summary['aov'].old_value" small is-money :prefix="currencyCode"
		                       :startDate="chartStart" :endDate="chartEnd" :loading="loading['aov']">
			                <template v-slot:info>
				                This is the <b>Average Order Value</b> on all your funnels combined.
			                </template>
		                </chart>
	                </div>

	                <div class="layout-row" >
		                <chart title="Page views" :data="values['pageviews']" :old-data="oldValues['pageviews']"
		                       :total="summary['pageviews'].value" :old-total="summary['pageviews'].old_value" small
		                       :startDate="chartStart" :endDate="chartEnd" :loading="loading['pageviews']"/>

                    <chart title="Optins" :data="values['optins']" :old-data="oldValues['optins']" :round-value="true"
                           :total="summary['optins'].value" :old-total="summary['optins'].old_value" small
                           :startDate="chartStart" :endDate="chartEnd" :loading="loading['optins']"/>

                    <chart title="Optin rate" :data="values['optin_rate']" :old-data="oldValues['optin_rate']" suffix="%"
                           :total="summary['optin_rate'].value" :old-total="summary['optin_rate'].old_value" small
                           :startDate="chartStart" :endDate="chartEnd" :loading="loading['optin_rate']"/>
	                </div>
                </div>

                <div class="panel funnels-panel margin-t-25" v-if="top_funnels && top_funnels.length>0">
                    <div class="panel-head">
                        <h2>Top Funnels <i>🚀</i></h2>
                        <router-link to="/funnels" class="view-all">View All</router-link>
                    </div>
                    <div class="panel-body entries-table">
                        <div class="panel-item entry" v-for="(item, index) in top_funnels" :key="index">
                            <router-link :to="(item.funnel_type===1 ? '/wfunnel/' : '/funnel/')+item.funnel_id" class="list-item-link">
                                <div class="panel-item-cell panel-item-title" style="flex: 1">
                                    <div class="list-item-title">{{ item.funnel_name }}</div>
                                    <span>{{ item.updated_at }}</span>
                                </div>
                                <div class="panel-item-cell" style="width: 80px;">
                                    <div class="cell-title">Revenue</div>
                                    <div class="cell-value">{{currencySymbol(item.currency_code) + getShort(item.revenue,1,false)}}</div>
                                </div>
                                <div class="panel-item-cell" style="width: 60px;">
                                    <div class="cell-title">Orders</div>
                                    <div class="cell-value">{{item.orders}}</div>
                                </div>
                                <div class="panel-item-cell">
                                    <div class="cell-title">Conversion rate</div>
                                    <div class="cell-value cell-info">
                                        <div class="small-text">{{ percentage(item.orders, item.visits) }}%</div>
                                        <div class="delta delta-up">{{ percentage(item.last_orders, item.last_visits) }}%</div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MainRight show="true"/>
    </div>
</template>

<script>

import MainRight from "@/components/MainRight.vue";
import MainSearch from "@/components/MainSearch.vue"
import DashboardBanner from "../components/DashboardBanner.vue";
import API from "@/api"
import Loading from "@/components/Loading.vue"
import {getSymbol} from "@/helpers/currencies"
import shortValue from "@/helpers/shortValue"
import FunnelEntry from "@/components/base/funnel-entry";
import analytics, {percentage} from "@/helpers/analytics";
// import moment from "moment";
const moment = require('moment-timezone');

import Chart from "@/components/base/chart";
import RangePicker from "@/components/base/range-picker";
import Filters_panel from "@/views/funnels/funnel-plus/funnel/analytics/filters_panel";

export default {
  name: "MainLayout",
	title:"Home | Funnelish™",
  components: {
	  Filters_panel,
    RangePicker,
    Chart,
    FunnelEntry,
    MainRight,
    MainSearch,
    DashboardBanner,
    Loading
  },
  mixins: [API],
  data: function() {
      return {
	      top_funnels: [],

        unit: "day",
        maxDate: new Date(),
        startDate: new Date(),
        endDate: new Date(),
	      currentRange: "Last 30 days",

        // Purchase values
	      revenue: 0,
	      oldRevenue: 0,
	      revenueData: [{value:0},{value:0}],
	      oldRevenueData: [{value:0},{value:0}],

	      // AOV
	      aovValue: 0,
	      oldAovValue: 0,
	      aovValues: [{value:0},{value:0}],
	      oldAovValues: [{value:0},{value:0}],

        // Purchases
        orders: 0,
        oldOrders: 0,
        ordersData: [{value:0},{value:0}],
        oldOrdersData: [{value:0},{value:0}],

        // Conv. rate
        convRate: 0,
        oldConvRate: 0,
        convRates: [{value:0},{value:0}],
        oldConvRates: [{value:0},{value:0}],

        // Visitors
        visitors: 0,
        oldVisitors: 0,
        visitorsData: [{value:0},{value:0}],
        oldVisitorsData: [{value:0},{value:0}],

        // Optins
        optins: 0,
        oldOptins: 0,
        optinsData: [{value:0},{value:0}],
        oldOptinsData: [{value:0},{value:0}],

        // Optin rate
        optinRate: 0,
        oldOptinRate: 0,
        optinRates: [{value:0},{value:0}],
        oldOptinRates: [{value:0},{value:0}],


	      loading: {
					'aov':true,
		      'revenue':true,
		      'optins':true,
		      'orders':true,
		      'pageviews':true,
		      'unique_visits': true,
		      'unique_orders': true,
		      'optin_rate': true,
		      'conv_rate': true,
	      },
	      values:{
					'aov':[],
		      'revenue':[],
		      'orders':[],
		      'optins':[],
		      'pageviews':[],
		      'unique_visits': [],
		      'unique_orders':[],
		      'optin_rate':[],
		      'conv_rate':[],
	      },
	      summary:{
					'aov':{},
		      'revenue': {},
		      'orders': {},
		      'optins': {},
		      'pageviews': {},
		      'unique_visits': {},
		      'unique_orders':{},
		      'optin_rate':{},
		      'conv_rate':{},
	      },
	      oldValues:{
		      'aov':[
			      {date:moment(),value:0}
		      ],
		      'revenue':[
			      {date:moment(),value:0}
		      ],
		      'orders':[
			      {date:moment(),value:0}
		      ],
		      'pageviews':[
			      {date:moment(),value:0}
		      ],
		      'unique_orders':[
			      {date:moment(),value:0}
		      ],
		      'unique_visits':[
			      {date:moment(),value:0}
		      ],
		      'conv_rate':[
			      {date:moment(),value:0}
		      ],
		      'optin_rate':[
			      {date:moment(),value:0}
		      ],
	      },
	      chartsLoaded: false,
	      on_boarding: {},
        // banerOpened: true,
        topFunnels: []
      };
  },
  computed: {
    currencyCode() {
	    if (!this.$store.state.userInfo) return '$';
	    let c = this.$store.state.userInfo.default_currency_code;
	    return getSymbol(c) || '$';
    },
    chartStart() {
	    return analytics.formatChartDate(this.unit,this.startDate);
    },
	  oldStartDate() {
		  if (this.unit==="hour") {
			  let days = moment(this.endDate).diff(this.startDate, "hours")+1;
			  let start = moment(this.startDate).subtract(days, "hours").startOf('day');

			  return start;
		  } else {
			  let days = moment(this.endDate).diff(this.startDate, "days")+1;
			  let start = moment(this.startDate).subtract(days, "days").startOf('day');

			  return start;
		  }
	  },
    chartEnd() {
	    return analytics.formatChartDate(this.unit, this.endDate);
    },
    oldEndDate() {
    	if (this.unit==="hour") {
		    let end = moment(this.startDate).subtract(1, "hours").endOf('day');
		    return end;
	    } else {
		    let end = moment(this.startDate).subtract(1, "days").endOf('day');
		    return end;
	    }
    },
	  minDate() {
		  return this.$store.state.userInfo ? moment(this.$store.state.userInfo.created) :
				  moment();
	  }
  },
  methods: {
	  getDataFromTrends(unit, trends, startDate, endDate) {
		  let data = [];

		  let date = moment(startDate).add(1, 'hour').startOf('day');

		  // take min date either NOW or endDate.
		  let endD = moment.min([endDate, moment()]);

		  if (!trends || trends.length === 0) {
			  data = [{value: 0, date: date, brief: this.unitToBrief(unit, date.unix())}, {
				  value: 0, date: endD, brief: this.unitToBrief(unit, endD.unix())
			  }];
		  } else {
			  for (let i = 0; i < trends.length; i++) {
				  let t = trends[i];

				  data.push({
					  value: t.value,
					  brief: this.unitToBrief(unit, t.date),
					  date: moment.unix(t.date),
					  // day: t.day,
					  // month: t.month,
					  // week: t.week,
					  // year: t.year, // date: t.date,
					  // hour: t.hour,
				  })
			  }
		  }
		  this.cleanData(unit, data, startDate, endDate);
		  return data;
	  },
	  // Adds missing days...
	  cleanData(unit, data, startDate, endDate) {

		  // cap endDate to today.
		  if (moment().diff(endDate, "hours") < 0) endDate = moment()
		  if (moment().diff(startDate, "hours") < 0) startDate = moment()

		  let unitsDiff = Math.abs(moment(endDate).diff(startDate, unit)) + 1;

		  // console.log('cleanData', unitsDiff, startDate, endDate, unit)

		  for (let i = 0; i < unitsDiff; i++) {
			  let date = moment(startDate).add(i, unit);
			  let entry = this.findEntryInData(date, data, unit);

			  if (!entry) {
				  data.splice(i, 0, {value: 0, date: date, brief: this.unitToBrief(unit, date.unix())})
			  }
		  }
	  },
	  findEntryInData(date, data, unit) {
		  for (let i = 0; i < data.length; i++) {
			  if (moment(data[i].date).isSame(date, unit+"s")) {
				  return data[i];
			  }
		  }
		  return null;
	  },
	  unitToBrief(unit, date)  {
		  let newDate = moment.unix(date);
		  switch (unit) {
			  case "week": {
				  let from_date = newDate.startOf('week');
				  let to_date = newDate.endOf('week');
				  return from_date.format("DD MMM") + " - " + to_date.format("DD MMM");
			  }
			  case "month":
				  return newDate.format("MMM YYYY");
			  case "hour": {
				  if (moment().isSame(newDate, "day")) {
					  return "Today - "+newDate.format("HH:00");
				  } else if (moment().subtract(1, "days").isSame(newDate, "day")) {
					  return "Yesterday - "+newDate.format("HH:00");
				  }
				  return newDate.format("ddd DD - HH:00");
			  }
			  default:
				  return newDate.utcOffset(0,false).format("DD MMM")
		  }
	  },
	  async loadChart(chart='revenue') {
		  try {
			  this.loading[chart] = true;

			  // load only if charts are expanded
			  // if (this.expandCharts) {
				  let data = await this.api.analytics.getTrends_v2(chart, 0, this.startDate, this.endDate, this.unit, this.getConditions());
				  let data2 = await this.api.analytics.getTrends_v2(chart, 0, this.oldStartDate, this.oldEndDate, this.unit, this.getConditions());
				  // console.log('loadChart', this.startDate, this.endDate)

				  this.values[chart] = this.getDataFromTrends(this.unit, data, this.startDate, this.endDate)
				  this.oldValues[chart] = this.getDataFromTrends(this.unit, data2, this.oldStartDate, this.oldEndDate)

				  this.chartsLoaded = true;
			  // } else {
				//   this.chartsLoaded = false;
			  // }

			  await this.loadSummary(chart)
		  } catch (e) {
			  console.error(e)
		  } finally {
			  this.loading[chart] = false;
		  }
	  },
	  getConditions() {
		  let s = localStorage.getItem("filterConditions")
		  if (s) {
			  try {
				  return JSON.parse(s)
			  } catch (e) {
				  console.warn(e)
			  }
		  }
		  return []
	  },
	  async loadSummary(chart='revenue') {
		  try {
			  this.loading[chart] = true;
			  let data = await this.api.analytics.getSummary_v2(chart, 0,
					  this.startDate, this.endDate, this.oldStartDate, this.oldEndDate, this.getConditions());

			  this.summary[chart] = data;

			  // this.values[chart] = data
		  } catch (e) {
			  console.error(e)
		  } finally {
			  this.loading[chart] = false;
		  }
	  },
    percentage(sub,total) {
	    return shortValue(percentage(sub,total), 2)
    },
    rangeChanged(currentRange, startDate, endDate) {
	    this.startDate = startDate;
	    this.endDate = endDate;
	    this.currentRange = currentRange;

	    this.storeRange();

	    this.loadAnalytics();
    },
    storeRange() {
    	analytics.storeRange(this.currentRange, this.startDate, this.endDate);
    },
    loadRange() {
	    let {currentRange, startDate, endDate} = analytics.loadRange();

	    this.currentRange = currentRange;
	    this.endDate = endDate;
	    this.startDate = startDate;
    },

    //UI
    getShort(value, digits, money=false) {
        return shortValue(value, digits, money);
    },
    // Calculates conversion, optin rate
    currencySymbol(code) {
        return code.length ? getSymbol(code) : '';
    },
    async loadAnalytics() {
	    try {
		    // this.loading = true;

		    // get startdate enddate.
		    let {startDate, endDate} = analytics.rangeToTime(this.currentRange, this.startDate, this.endDate, this.minDate);
		    this.startDate = startDate;
		    this.endDate = endDate;

		    // Convert local times into UTC
		    // endDate = new Date(endDate).getTime();
		    // startDate = new Date(startDate).getTime();
		    // let oldStartDate = new Date(this.oldStartDate).getTime();
		    // let oldEndDate = new Date(this.oldEndDate).getTime();

		    let unit = "day";
		    let days = Math.abs(moment(this.endDate).diff(this.startDate, "days"))+1;
		    if (days > 6*30) {
			    unit = "month";
		    } else if (days > 31) {
			    unit = "week";
		    } else if (days <= 2) {
		    	unit = "hour"
		    }
		    this.unit = unit;


		    this.loadChart('revenue')
		    // this.loadChart('orders')
		    this.loadChart('aov')
		    this.loadChart('pageviews')
		    this.loadChart('optins')
		    this.loadChart('unique_orders')
		    this.loadChart('conv_rate')
		    this.loadChart('optin_rate')


		    let data = await this.api.analytics.dashboard(this.startDate, this.endDate, unit);
		    let funnels = [];
		    if (data.top_funnels)
			    data.top_funnels.forEach(x => funnels.push(x.funnel_id))
		    this.on_boarding = data.on_boarding;

		    let oldData = await this.api.analytics.dashboard(this.oldStartDate, this.oldEndDate, unit, funnels);

		    // Revenue
		    this.revenue = data.revenue;
		    this.revenueData = analytics.getDataFromTrends(this.unit, data.trends, "revenue", this.startDate, this.endDate)
		    this.oldRevenue = oldData.revenue;
		    this.oldRevenueData = analytics.getDataFromTrends(this.unit, oldData.trends, "revenue", this.oldStartDate, this.oldEndDate)

		    // AOV
		    this.aovValue = data.aov;
		    this.aovValues = analytics.getDataFromTrends(this.unit, data.trends, "aov", this.startDate, this.endDate)
		    this.oldAovValue = oldData.aov;
		    this.oldAovValues = analytics.getDataFromTrends(this.unit, oldData.trends, "aov", this.oldStartDate, this.oldEndDate)

		    // Purchases
		    this.orders = data.orders;
		    this.ordersData = analytics.getDataFromTrends(this.unit, data.trends, "orders", this.startDate, this.endDate)
		    this.oldOrders = oldData.orders;
		    this.oldOrdersData = analytics.getDataFromTrends(this.unit, oldData.trends, "orders", this.oldStartDate, this.oldEndDate)

		    // Visitors
		    this.visitors = data.visits;
		    this.oldVisitors = oldData.visits;
		    if (unit === "hour") {  // handle hourly data differently
			    this.visitorsData = analytics.getDataFromTrends(this.unit, data.hourly_visitors, "visits", this.startDate, this.endDate)
			    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, oldData.hourly_visitors, "visits", this.oldStartDate, this.oldEndDate)
		    } else {
			    this.visitorsData = analytics.getDataFromTrends(this.unit, data.trends, "visits", this.startDate, this.endDate)
			    this.oldVisitorsData = analytics.getDataFromTrends(this.unit, oldData.trends, "visits", this.oldStartDate, this.oldEndDate)
		    }

		    // Opt-ins
		    this.optins = data.optins;
		    this.optinsData = analytics.getDataFromTrends(this.unit, data.trends, "optins", this.startDate, this.endDate)
		    this.oldOptins = oldData.optins;
		    this.oldOptinsData = analytics.getDataFromTrends(this.unit, oldData.trends, "optins", this.oldStartDate, this.oldEndDate)

		    // Conversion rates
		    this.convRate = percentage(this.orders, this.visitors);
		    this.convRates = analytics.generateRates(this.visitorsData, this.ordersData);
		    this.oldConvRate = percentage(this.oldOrders, this.oldVisitors);
		    this.oldConvRates = analytics.generateRates(this.oldVisitorsData, this.oldOrdersData);

		    // Optin rates
		    this.optinRate = percentage(this.optins, this.visitors);
		    this.optinRates = analytics.generateRates(this.visitorsData, this.optinsData);
		    this.oldOptinRate = percentage(this.oldOptins, this.oldVisitors);
		    this.oldOptinRates = analytics.generateRates(this.oldVisitorsData, this.oldOptinsData);

				this.generateTopFunnels(data.top_funnels, oldData.top_funnels)
	    } catch (e) {
		    console.error("ERROR", e);
		    this.$notify({
			    group: 'main',
			    title: "Something went wrong! try again.",
			    type: 'error',
		    });
	    } finally {
		    // this.loading = false;
	    }
    },
	  generateTopFunnels(newFunnels, oldFunnels) {
		  let topFunnels = [];

		  for (let i = 0; i < newFunnels.length; i++) {
		  	let n = newFunnels[i];
		  	let old = oldFunnels.find(x => x.funnel_id===n.funnel_id);
		  	if (old) {
				  n.last_revenue = old.revenue;
				  n.last_visits = old.visits;
				  n.last_orders = old.orders;
			  }
		  	topFunnels.push(n);
		  }


		  this.top_funnels = topFunnels;

	  }
  },
	mounted() {
	},
	created() {

	  this.loadRange();
    this.loadAnalytics();
  }
}
</script>
<style lang="scss" scoped>
.chart-box {
	display: flex;
}
.chart {
	margin: 10px;
}
</style>
